export default __webpack_public_path__ + "static/assets/b277b8762debfb5c3a6b8b9c7894d215.gif";